export const APPEND_NOTIFICATION = "APPEND_NOTIFICATION";

export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";
